import { EventDetailsType, ServiceTimesType } from './types'

export const occasionRequirements: EventDetailsType = {
  id: 'requirements',
  label: 'What is required?',
  type: 'checkbox',
  needs: [],
  prefill: true,
  options: [
    {
      label: 'Food',
      value: 'FOOD',
    },
    {
      label: 'Alcoholic Drinks',
      value: 'ALCOHOLIC_DRINKS',
    },
    {
      label: 'Non Alcoholic Drinks',
      value: 'NON_ALCOHOLIC_DRINKS',
    },
    {
      label: 'Event Staffing',
      value: 'EVENT_STAFFING',
    },
    {
      label: 'Equipment Hire',
      value: 'EQUIPMENT_HIRE',
    },
    {
      label: 'Bartender / Mixologist',
      value: 'BARTENDER_MIXOLOGIST',
    },
  ],
}

export const occasionOnsiteFacilities: EventDetailsType = {
  id: 'onsiteFacilities',
  label: 'What kitchen facilities are onsite?',
  type: 'checkbox',
  needs: [],
  prefill: true,
  options: [
    {
      label: 'Sink / Tap',
      value: 'SINK_TAP',
    },
    {
      label: 'Power Supply',
      value: 'POWER_SUPPLY',
    },
    {
      label: 'Fridge',
      value: 'FRIDGE',
    },
    {
      label: 'Service Space',
      value: 'SERVICE_SPACE',
    },
    {
      label: 'Oven',
      value: 'OVEN',
    },
    {
      label: 'Cooking onsite allowed',
      value: 'COOKING_ONSITE_ALLOWED',
    },
  ],
}

// Radio

export const occasionServiceStyle: EventDetailsType = {
  id: 'serviceStyle',
  label: 'What type of service style?',
  type: 'radio',
  needs: [],
  prefill: true,
  options: [
    {
      label: 'Cocktail Tray Service',
      value: 'COCKTAIL_TRAY_SERVICE',
    },
    {
      label: 'Self-serve',
      value: 'SELF_SERVE',
    },
    {
      label: 'Buffet Staff Service',
      value: 'BUFFET_STAFF_SERVICE',
    },
    {
      label: 'Cook & Serve',
      value: 'COOK_AND_SERVE',
    },
  ],
}

export const occasionEventStyle: EventDetailsType = {
  id: 'eventStyle',
  label: 'What is the event style?',
  type: 'radio',
  needs: [],
  prefill: true,
  options: [
    {
      label: 'Cocktail Party',
      value: 'COCKTAIL_PARTY',
    },
    {
      label: 'BBQ',
      value: 'BBQ',
    },
    {
      label: 'Grazing Platters',
      value: 'GRAZING_PLATTERS',
    },
    {
      label: 'Seated Dining',
      value: 'SEATED_DINING',
    },
    {
      label: 'Buffet',
      value: 'BUFFET',
    },
    {
      label: 'Pop-up',
      value: 'POP_UP',
    },
  ],
}

export const eventDetailsServingType: EventDetailsType = {
  id: 'servingType',
  label: 'emma:preferences_requirementsSubtitle',
  type: 'radio',
  needs: [],
  prefill: true,
  options: [
    {
      label: 'emma:preferences_requirements_individual',
      value: 'INDIVIDUAL',
    },
    {
      label: 'emma:preferences_requirements_sharing',
      value: 'SHARING',
    },
    {
      label: 'emma:preferences_requirements_both',
      value: 'BOTH',
    },
  ],
}

// Service Times
export const occasionFoodServiceTime: ServiceTimesType = {
  id: 'foodServiceTime',
  label: 'Food service time',
  type: 'serviceTime',
  needs: [
    {
      id: 'requirements',
      value: 'FOOD',
    },
  ],
  prefill: false,
}

export const occasionStaffServiceTime: ServiceTimesType = {
  id: 'staffServiceTime',
  label: 'Staff service time',
  type: 'serviceTime',
  needs: [
    {
      id: 'requirements',
      value: 'EVENT_STAFFING',
    },
  ],
  prefill: false,
}
